export default "__VITE_ASSET__CB8ACUoI__"